import React, { useState } from "react"; 
import axios from 'axios';
import { BACKEND_URL } from "../../../consts";

const SearchTreeSp = ({ item }) => {
    const [childData, setChildData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const fetchChildren = async (parentId) => {
        try {
            const response = await axios.get(`${BACKEND_URL}/api/v1/tnved/tree?parentId=${parentId}`);
            setChildData(response.data.children);
        } catch (err) {
            console.error("Ошибка: ", err);
        }
    };


    const handleClick = () => {
        if (!isOpen) {
            fetchChildren(item.id);
        }
        setIsOpen(!isOpen); 
    };

    return (
        <div className="">
            <div className={`flex items-start sm:items-center gap-[15px] my-[9px]`}>
                <div className={`flex items-center gap-[8px] ${item.is10 && 'ml-[30px]'}`}>
                    {
                        !item.is10 &&
                        <button 
                        className={`w-[24px] h-[24px] rounded-[100px] flex items-center justify-center ${isOpen && 'border-[1px] border-solid'}`}
                        onClick={handleClick} 
                        style={{
                            backgroundColor: !isOpen ? '#1F2225' : '',
                            borderColor: '#1F2225'
                        }}>
                            {!isOpen ? 
                                <img src="/img/search/searchTreePlus.svg" alt="Toggle" /> 
                                : 
                                <img src="/img/search/searchTreeMinus.svg" alt="Toggle" />
                            }
                    </button>
                    }
                    
                    <div className={`py-[6px] px-[12px] rounded-[8px] sm:text-[16px text-[14px]`}
                    style={{
                        color: '#fff',
                        backgroundColor: !item.is10 ? '#1F2225' : '#D42323'
                    }}
                    >
                        {item.code}
                    </div>
                </div>
                <div className={`max-w-[80%] leading-[1.3] sm:text-[16px] text-[13px] lowercase`}>
                    {item.treeName}
                </div>
            </div>

            {isOpen && (
                <div className={`sm:pl-[20px] pl-[7px]`}> 
                {
                    childData.map((el, index) => (
                        <SearchTreeSp key={index} item={el} />
                    ))
                }
                    
                </div>
            )}
        </div>
    );
};

export default SearchTreeSp;
